import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  activeTabIndex:0,
	  
	  mainBody:'',
	  
	  currentVR:'',
	  currentProductTypeIndex:0,
	  currentProduct:'',
	  currentMRP:'',
	  currentShop:'' 
  },
  getters: {
	  
	  getMainBody(state, getters){
		return state.mainBody;
	  }
	  
  },
  mutations: {
	  
	  setActiveTabIndex(state, stateVal){
		  state.activeTabIndex = stateVal;
	  },
	  
	  setMainBody(state, stateVal){
		state.mainBody = stateVal;
	  },
	  
	  setCurrentShowVR(state, stateVal){
		  state.currentVR = stateVal;
	  },
	  
	  setCurrentProductTypeIndex(state, stateVal){
		  state.currentProductTypeIndex = stateVal;
	  },
	  
	  setCurrentProduct(state, stateVal){
		  state.currentProduct = stateVal;
	  }, 
	  
	  setCurrentMRP(state, stateVal){
		  state.currentMRP = stateVal;
	  },
	  
	  setCurrentShop(state, stateVal){
		  state.currentShop = stateVal;
	  } 
	   
  },
  actions: {
  },
  modules: {
  }
})
